import { render, staticRenderFns } from "./UpdateConcept.vue?vue&type=template&id=5b38681e&scoped=true"
import script from "./UpdateConcept.vue?vue&type=script&lang=js"
export * from "./UpdateConcept.vue?vue&type=script&lang=js"
import style0 from "./UpdateConcept.vue?vue&type=style&index=0&id=5b38681e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38681e",
  null
  
)

export default component.exports